import { BaseCommunicationPreference } from './base-communication-preference.model';

export class CommunicationPreference extends BaseCommunicationPreference {

}
